<template>
  <v-container>
    <v-row>
      <v-col cols="12" xs="12" sm="4" class>
        <div>Zeit: {{ station.date }} {{ station.time }}</div>
      </v-col>
      <v-col cols="12" xs="12" sm="4" class>
        <div>Update Intervall: {{ updateIntervall }} s</div>
      </v-col>
      <v-col cols="12" xs="12" sm="4" class>
        <div>Nächstes Update in: {{ nextUpdate }} s</div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" xs="12" sm="2" class="wind">
        <div>Wind</div>
        <div>{{ station.wind }} km/h</div>
      </v-col>
      <v-col cols="12" xs="12" sm="2" class="gust">
        <div>Böe</div>
        <div>k.a.</div>
      </v-col>
      <v-col cols="12" xs="12" sm="2" class="direction">
        <div>Richtung</div>
        <div>{{ station.direction }} °</div>
      </v-col>
      <v-col cols="12" xs="12" sm="2" class="temp">
        <div>Temp</div>
        <div>{{ station.temp }} °C</div>
      </v-col>
      <v-col cols="12" xs="12" sm="2" class="humidity">
        <div>Feucht.</div>
        <div>{{ station.hum }} %</div>
      </v-col>
      <v-col cols="12" xs="12" sm="2" class="pressure">
        <div>Druck</div>
        <div>{{ station.pressure }} hPa</div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" xs="12">
        <div v-if="!!error" class="error">Es trat ein Fehler bei der Abfrage auf.</div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    updateIntervall: 70,
    nextUpdate: 70,
    station: {
      wind: 0,
      gust: 0,
      direction: 0,
      temp: 0,
      hum: 0,
      pressure: 0,
      date: "",
      time: ""
    },
    url: "weatherdata.php",
    error: ""
  }),
  methods: {
    getLiveData(force = false) {
      if (this.nextUpdate <= 0 || force == true) {
        this.error = "";
        axios
          .get(this.url)
          .then(resp => {
            this.station.wind = resp.data.wind;
            this.station.direction = resp.data.wdirection;
            //this.station.gust = 0;
            this.station.pressure = resp.data.pressure;
            this.station.hum = resp.data.humidity;
            this.station.temp = resp.data.temperature;
            this.station.date = resp.data.date;
            this.station.time = resp.data.time;
          })
          .catch(error => {
            this.error = error.message;
          });
        this.nextUpdate = this.updateIntervall;
      }
      this.nextUpdate--;
    }
  },
  create() {
    this.nextUpdate = this.updateIntervall;
  },
  mounted() {
    this.getLiveData(true);
    setInterval(this.getLiveData, 1000);
  }
};
</script>

<style scoped>
.error {
  background-color: lightsalmon;
  color: white;
  padding: 5px;
}
.wind {
  border-top: 2px solid lightblue;
}

.gust {
  border-top: 2px solid violet;
}

.direction {
  border-top: 2px solid lightcoral;
}

.temp {
  border-top: 2px solid yellowgreen;
}

.humidity {
  border-top: 2px solid yellow;
}

.pressure {
  border-top: 2px solid lightslategray;
}
</style>
